import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_CEP_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ListaCepRequest } from './types';

// ACTIONS
import { listaCepSuccess, listaCepFailure } from './actions';

function* listaCepRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ListaCepRequest } =
		request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_CEP_API,
		`v3/enderecos`,
		payload,
	);

	if (response.status === 200 || response.status === 202) {
		yield put(listaCepSuccess(response.data));
	} else {
		yield put(listaCepFailure([]));
	}
}

export default all([takeLatest(Types.LISTA_CEP, listaCepRequest)]);
